import { FC } from 'react';
import map from 'lodash/map';
import Item from 'antd/lib/form/FormItem';
import Col from 'antd/lib/grid/col';
import Row from 'antd/lib/grid/row';
import Input from 'antd/lib/input/Input';

import { paymentsRecipientFields } from 'components/Settings/fieldsConstants';

const PaymentsRecipientAddress: FC = () => (
  <>
    <h4 className="mt-4 mb-5">Recipient Address</h4>
    <Row gutter={20}>
      {map(paymentsRecipientFields, (field) =>
        <Col span={12} key={field.name}>
          <Item {...field}>
            <Input size="large" placeholder={`Enter ${field.label}`} />
          </Item>
        </Col>)}
    </Row>
  </>
);

export default PaymentsRecipientAddress;
